// Modules
import React from "react";

// Styles
import "./MvModal.sass"
import closeicon from "../static/images/ic-close.png"

// Components
import MvIcon from "Generic/MvIcon";
import { logLinkInfoAnalyticData } from "Utils/analytics";

type Props = {
    openModal: boolean;
    toggleModal: () => void;
    id?: string
    scrollY?: boolean;
    iconColor?: string;
    closeiconnato?: boolean;
}

class MvModal extends React.Component<Props> {


    render(){
      if (!this.props.openModal) {
          return false;
      }
      function trackCloseEvent() {
        logLinkInfoAnalyticData({ 
          event: 'hopperCancelDepartureNo', 
          pageName:'Hotel Landing Page - Hopper',
          linkClickPage: 'Hopper External Booking Page',
          linkClickRegion:"NATO",
          linkName:"Click Departure No",
          siteSection: 'Points', 
        }) 
      }

        return (
            <React.Fragment>
                <section
                  className={`${!this.props.openModal ? "main-overlay hide" : "main-overlay"} ${this.props.scrollY ? "scroll-y" : ""}`}
                  id={this.props.id ? this.props.id : ""}
                >
                    <div className="content">
                        <div className="modal-top">
                               {this.props.children}
                               <button
                                 className="times-button"
                                 onClick={this.props.toggleModal}
                               >
                                {this.props.closeiconnato ? <img src={closeicon} onClick={() => trackCloseEvent()} alt="" /> : 
                                 <span className='close-icon-vcap' onClick={() => trackCloseEvent()}></span>
                                }
                               </button>
                        </div>
                    </div>
                </section>
                <div
                  className={!this.props.openModal ? "black-overlay hide" : "black-overlay"}
                  onClick={this.props.toggleModal}
                >
                </div>
            </React.Fragment>
        )
    }
}

export default MvModal
